/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails';
import { ModulesPointsRacesApplicationPointsRacePlayersPointsRacePlayerResponse } from '../model/modulesPointsRacesApplicationPointsRacePlayersPointsRacePlayerResponse';
import { ModulesPointsRacesApplicationPointsRacePointsPointsRacePointsResponse } from '../model/modulesPointsRacesApplicationPointsRacePointsPointsRacePointsResponse';
import { ModulesPointsRacesApplicationPointsRacesPointsRaceResponse } from '../model/modulesPointsRacesApplicationPointsRacesPointsRaceResponse';
import { ModulesPointsRacesEndpointsContractsPointsRacePlayersCreatePointsRacePlayerRequestModel } from '../model/modulesPointsRacesEndpointsContractsPointsRacePlayersCreatePointsRacePlayerRequestModel';
import { ModulesPointsRacesEndpointsContractsPointsRacePlayersUpdatePointsRacePlayerRequestModel } from '../model/modulesPointsRacesEndpointsContractsPointsRacePlayersUpdatePointsRacePlayerRequestModel';
import { ModulesPointsRacesEndpointsContractsPointsRacePointsCreatePointsRacePointsRequestModel } from '../model/modulesPointsRacesEndpointsContractsPointsRacePointsCreatePointsRacePointsRequestModel';
import { ModulesPointsRacesEndpointsContractsPointsRacePointsUpdatePointsRacePointsRequestModel } from '../model/modulesPointsRacesEndpointsContractsPointsRacePointsUpdatePointsRacePointsRequestModel';
import { ModulesPointsRacesEndpointsContractsPointsRacesCreatePointsRaceRequest } from '../model/modulesPointsRacesEndpointsContractsPointsRacesCreatePointsRaceRequest';
import { ModulesPointsRacesEndpointsContractsPointsRacesUpdatePointsRaceRequestModel } from '../model/modulesPointsRacesEndpointsContractsPointsRacesUpdatePointsRaceRequestModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { PointsRacesServiceInterface }                            from './pointsRaces.serviceInterface';


@Injectable()
export class PointsRacesService implements PointsRacesServiceInterface {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Gets a PointsRace.
     * Gets a PointsRace using the PointsRace identifier.
     * @param pointsRaceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPointsRaceByIdEndpoint(pointsRaceId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesPointsRacesApplicationPointsRacesPointsRaceResponse>;
    public getPointsRaceByIdEndpoint(pointsRaceId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesPointsRacesApplicationPointsRacesPointsRaceResponse>>;
    public getPointsRaceByIdEndpoint(pointsRaceId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesPointsRacesApplicationPointsRacesPointsRaceResponse>>;
    public getPointsRaceByIdEndpoint(pointsRaceId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pointsRaceId === null || pointsRaceId === undefined) {
            throw new Error('Required parameter pointsRaceId was null or undefined when calling getPointsRaceByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesPointsRacesApplicationPointsRacesPointsRaceResponse>('get',`${this.basePath}/pointsRaces/${encodeURIComponent(String(pointsRaceId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a PointsRacePlayer.
     * Gets a PointsRacePlayer using the PointsRace and PointsRacePlayer identifiers.
     * @param pointsRaceId 
     * @param pointsRacePlayerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPointsRacePlayerByIdEndpoint(pointsRaceId: string, pointsRacePlayerId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesPointsRacesApplicationPointsRacePlayersPointsRacePlayerResponse>;
    public getPointsRacePlayerByIdEndpoint(pointsRaceId: string, pointsRacePlayerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesPointsRacesApplicationPointsRacePlayersPointsRacePlayerResponse>>;
    public getPointsRacePlayerByIdEndpoint(pointsRaceId: string, pointsRacePlayerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesPointsRacesApplicationPointsRacePlayersPointsRacePlayerResponse>>;
    public getPointsRacePlayerByIdEndpoint(pointsRaceId: string, pointsRacePlayerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pointsRaceId === null || pointsRaceId === undefined) {
            throw new Error('Required parameter pointsRaceId was null or undefined when calling getPointsRacePlayerByIdEndpoint.');
        }

        if (pointsRacePlayerId === null || pointsRacePlayerId === undefined) {
            throw new Error('Required parameter pointsRacePlayerId was null or undefined when calling getPointsRacePlayerByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesPointsRacesApplicationPointsRacePlayersPointsRacePlayerResponse>('get',`${this.basePath}/pointsRaces/${encodeURIComponent(String(pointsRaceId))}/players/${encodeURIComponent(String(pointsRacePlayerId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all PointsRacePlayers.
     * Gets all PointsRacePlayers for a PointsRace identifier.
     * @param pointsRaceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPointsRacePlayersEndpoint(pointsRaceId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesPointsRacesApplicationPointsRacePlayersPointsRacePlayerResponse>>;
    public getPointsRacePlayersEndpoint(pointsRaceId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesPointsRacesApplicationPointsRacePlayersPointsRacePlayerResponse>>>;
    public getPointsRacePlayersEndpoint(pointsRaceId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesPointsRacesApplicationPointsRacePlayersPointsRacePlayerResponse>>>;
    public getPointsRacePlayersEndpoint(pointsRaceId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pointsRaceId === null || pointsRaceId === undefined) {
            throw new Error('Required parameter pointsRaceId was null or undefined when calling getPointsRacePlayersEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesPointsRacesApplicationPointsRacePlayersPointsRacePlayerResponse>>('get',`${this.basePath}/pointsRaces/${encodeURIComponent(String(pointsRaceId))}/players`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all PointsRacePoints.
     * Gets all PointsRacePoints for a PointsRace identifier.
     * @param pointsRaceId 
     * @param pointsRacePointsId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPointsRacePointsByIdEndpoint(pointsRaceId: string, pointsRacePointsId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesPointsRacesApplicationPointsRacePointsPointsRacePointsResponse>>;
    public getPointsRacePointsByIdEndpoint(pointsRaceId: string, pointsRacePointsId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesPointsRacesApplicationPointsRacePointsPointsRacePointsResponse>>>;
    public getPointsRacePointsByIdEndpoint(pointsRaceId: string, pointsRacePointsId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesPointsRacesApplicationPointsRacePointsPointsRacePointsResponse>>>;
    public getPointsRacePointsByIdEndpoint(pointsRaceId: string, pointsRacePointsId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pointsRaceId === null || pointsRaceId === undefined) {
            throw new Error('Required parameter pointsRaceId was null or undefined when calling getPointsRacePointsByIdEndpoint.');
        }

        if (pointsRacePointsId === null || pointsRacePointsId === undefined) {
            throw new Error('Required parameter pointsRacePointsId was null or undefined when calling getPointsRacePointsByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesPointsRacesApplicationPointsRacePointsPointsRacePointsResponse>>('get',`${this.basePath}/pointsRaces/${encodeURIComponent(String(pointsRaceId))}/points/${encodeURIComponent(String(pointsRacePointsId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all PointsRacePoints.
     * Gets all PointsRacePoints for a PointsRace identifier.
     * @param pointsRaceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPointsRacePointsEndpoint(pointsRaceId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesPointsRacesApplicationPointsRacePointsPointsRacePointsResponse>>;
    public getPointsRacePointsEndpoint(pointsRaceId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesPointsRacesApplicationPointsRacePointsPointsRacePointsResponse>>>;
    public getPointsRacePointsEndpoint(pointsRaceId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesPointsRacesApplicationPointsRacePointsPointsRacePointsResponse>>>;
    public getPointsRacePointsEndpoint(pointsRaceId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pointsRaceId === null || pointsRaceId === undefined) {
            throw new Error('Required parameter pointsRaceId was null or undefined when calling getPointsRacePointsEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesPointsRacesApplicationPointsRacePointsPointsRacePointsResponse>>('get',`${this.basePath}/pointsRaces/${encodeURIComponent(String(pointsRaceId))}/points`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all PointsRaces.
     * Gets all PointsRaces.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPointsRacesEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesPointsRacesApplicationPointsRacesPointsRaceResponse>>;
    public getPointsRacesEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesPointsRacesApplicationPointsRacesPointsRaceResponse>>>;
    public getPointsRacesEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesPointsRacesApplicationPointsRacesPointsRaceResponse>>>;
    public getPointsRacesEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesPointsRacesApplicationPointsRacesPointsRaceResponse>>('get',`${this.basePath}/pointsRaces`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a PointsRace.
     * Removes a PointsRace using the PointsRace identifier.
     * @param pointsRaceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pointsRacesPointsRaceIdDelete(pointsRaceId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public pointsRacesPointsRaceIdDelete(pointsRaceId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public pointsRacesPointsRaceIdDelete(pointsRaceId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public pointsRacesPointsRaceIdDelete(pointsRaceId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pointsRaceId === null || pointsRaceId === undefined) {
            throw new Error('Required parameter pointsRaceId was null or undefined when calling pointsRacesPointsRaceIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/pointsRaces/${encodeURIComponent(String(pointsRaceId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a PointsRacePlayer.
     * Removes a PointsRacePlayer using the PointsRace and PointsRacePlayer identifiers.
     * @param pointsRaceId 
     * @param pointsRacePlayerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pointsRacesPointsRaceIdPlayersPointsRacePlayerIdDelete(pointsRaceId: string, pointsRacePlayerId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public pointsRacesPointsRaceIdPlayersPointsRacePlayerIdDelete(pointsRaceId: string, pointsRacePlayerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public pointsRacesPointsRaceIdPlayersPointsRacePlayerIdDelete(pointsRaceId: string, pointsRacePlayerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public pointsRacesPointsRaceIdPlayersPointsRacePlayerIdDelete(pointsRaceId: string, pointsRacePlayerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pointsRaceId === null || pointsRaceId === undefined) {
            throw new Error('Required parameter pointsRaceId was null or undefined when calling pointsRacesPointsRaceIdPlayersPointsRacePlayerIdDelete.');
        }

        if (pointsRacePlayerId === null || pointsRacePlayerId === undefined) {
            throw new Error('Required parameter pointsRacePlayerId was null or undefined when calling pointsRacesPointsRaceIdPlayersPointsRacePlayerIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/pointsRaces/${encodeURIComponent(String(pointsRaceId))}/players/${encodeURIComponent(String(pointsRacePlayerId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a PointsRacePlayer.
     * Updates a PointsRacePlayer based on the PointsRace and PointsRacePlayer idenfiers and UpdatePointsRacePlayerRequest.
     * @param pointsRaceId 
     * @param pointsRacePlayerId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pointsRacesPointsRaceIdPlayersPointsRacePlayerIdPut(pointsRaceId: string, pointsRacePlayerId: string, body?: ModulesPointsRacesEndpointsContractsPointsRacePlayersUpdatePointsRacePlayerRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public pointsRacesPointsRaceIdPlayersPointsRacePlayerIdPut(pointsRaceId: string, pointsRacePlayerId: string, body?: ModulesPointsRacesEndpointsContractsPointsRacePlayersUpdatePointsRacePlayerRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public pointsRacesPointsRaceIdPlayersPointsRacePlayerIdPut(pointsRaceId: string, pointsRacePlayerId: string, body?: ModulesPointsRacesEndpointsContractsPointsRacePlayersUpdatePointsRacePlayerRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public pointsRacesPointsRaceIdPlayersPointsRacePlayerIdPut(pointsRaceId: string, pointsRacePlayerId: string, body?: ModulesPointsRacesEndpointsContractsPointsRacePlayersUpdatePointsRacePlayerRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pointsRaceId === null || pointsRaceId === undefined) {
            throw new Error('Required parameter pointsRaceId was null or undefined when calling pointsRacesPointsRaceIdPlayersPointsRacePlayerIdPut.');
        }

        if (pointsRacePlayerId === null || pointsRacePlayerId === undefined) {
            throw new Error('Required parameter pointsRacePlayerId was null or undefined when calling pointsRacesPointsRaceIdPlayersPointsRacePlayerIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/pointsRaces/${encodeURIComponent(String(pointsRaceId))}/players/${encodeURIComponent(String(pointsRacePlayerId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a PointsRacePlayer.
     * Creates a PointsRacePlayer based on the PointsRace identifier and CreatePointsRacePlayerRequest request.
     * @param pointsRaceId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pointsRacesPointsRaceIdPlayersPost(pointsRaceId: string, body?: ModulesPointsRacesEndpointsContractsPointsRacePlayersCreatePointsRacePlayerRequestModel, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public pointsRacesPointsRaceIdPlayersPost(pointsRaceId: string, body?: ModulesPointsRacesEndpointsContractsPointsRacePlayersCreatePointsRacePlayerRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public pointsRacesPointsRaceIdPlayersPost(pointsRaceId: string, body?: ModulesPointsRacesEndpointsContractsPointsRacePlayersCreatePointsRacePlayerRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public pointsRacesPointsRaceIdPlayersPost(pointsRaceId: string, body?: ModulesPointsRacesEndpointsContractsPointsRacePlayersCreatePointsRacePlayerRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pointsRaceId === null || pointsRaceId === undefined) {
            throw new Error('Required parameter pointsRaceId was null or undefined when calling pointsRacesPointsRaceIdPlayersPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/pointsRaces/${encodeURIComponent(String(pointsRaceId))}/players`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a PointsRacePoint.
     * Removes a PointsRacePoint using the PointsRace and PointsRacePoint identifiers.
     * @param pointsRaceId 
     * @param pointsRacePointsId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pointsRacesPointsRaceIdPointsPointsRacePointsIdDelete(pointsRaceId: string, pointsRacePointsId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public pointsRacesPointsRaceIdPointsPointsRacePointsIdDelete(pointsRaceId: string, pointsRacePointsId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public pointsRacesPointsRaceIdPointsPointsRacePointsIdDelete(pointsRaceId: string, pointsRacePointsId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public pointsRacesPointsRaceIdPointsPointsRacePointsIdDelete(pointsRaceId: string, pointsRacePointsId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pointsRaceId === null || pointsRaceId === undefined) {
            throw new Error('Required parameter pointsRaceId was null or undefined when calling pointsRacesPointsRaceIdPointsPointsRacePointsIdDelete.');
        }

        if (pointsRacePointsId === null || pointsRacePointsId === undefined) {
            throw new Error('Required parameter pointsRacePointsId was null or undefined when calling pointsRacesPointsRaceIdPointsPointsRacePointsIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/pointsRaces/${encodeURIComponent(String(pointsRaceId))}/points/${encodeURIComponent(String(pointsRacePointsId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a PointsRacePoints.
     * Updates a PointsRacePoints based on the PointsRacePoints idenfier and UpdatePointsRacePointsRequest.
     * @param pointsRaceId 
     * @param pointsRacePointsId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pointsRacesPointsRaceIdPointsPointsRacePointsIdPut(pointsRaceId: string, pointsRacePointsId: string, body?: ModulesPointsRacesEndpointsContractsPointsRacePointsUpdatePointsRacePointsRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public pointsRacesPointsRaceIdPointsPointsRacePointsIdPut(pointsRaceId: string, pointsRacePointsId: string, body?: ModulesPointsRacesEndpointsContractsPointsRacePointsUpdatePointsRacePointsRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public pointsRacesPointsRaceIdPointsPointsRacePointsIdPut(pointsRaceId: string, pointsRacePointsId: string, body?: ModulesPointsRacesEndpointsContractsPointsRacePointsUpdatePointsRacePointsRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public pointsRacesPointsRaceIdPointsPointsRacePointsIdPut(pointsRaceId: string, pointsRacePointsId: string, body?: ModulesPointsRacesEndpointsContractsPointsRacePointsUpdatePointsRacePointsRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pointsRaceId === null || pointsRaceId === undefined) {
            throw new Error('Required parameter pointsRaceId was null or undefined when calling pointsRacesPointsRaceIdPointsPointsRacePointsIdPut.');
        }

        if (pointsRacePointsId === null || pointsRacePointsId === undefined) {
            throw new Error('Required parameter pointsRacePointsId was null or undefined when calling pointsRacesPointsRaceIdPointsPointsRacePointsIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/pointsRaces/${encodeURIComponent(String(pointsRaceId))}/points/${encodeURIComponent(String(pointsRacePointsId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a PointsRacePoints.
     * Creates a PointsRacePoints based on the CreatePointsRacePointsRequest request.
     * @param pointsRaceId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pointsRacesPointsRaceIdPointsPost(pointsRaceId: string, body?: ModulesPointsRacesEndpointsContractsPointsRacePointsCreatePointsRacePointsRequestModel, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public pointsRacesPointsRaceIdPointsPost(pointsRaceId: string, body?: ModulesPointsRacesEndpointsContractsPointsRacePointsCreatePointsRacePointsRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public pointsRacesPointsRaceIdPointsPost(pointsRaceId: string, body?: ModulesPointsRacesEndpointsContractsPointsRacePointsCreatePointsRacePointsRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public pointsRacesPointsRaceIdPointsPost(pointsRaceId: string, body?: ModulesPointsRacesEndpointsContractsPointsRacePointsCreatePointsRacePointsRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pointsRaceId === null || pointsRaceId === undefined) {
            throw new Error('Required parameter pointsRaceId was null or undefined when calling pointsRacesPointsRaceIdPointsPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/pointsRaces/${encodeURIComponent(String(pointsRaceId))}/points`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a PointsRace.
     * Updates a PointsRace based on the PointsRace idenfier and UpdatePointsRaceRequest.
     * @param pointsRaceId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pointsRacesPointsRaceIdPut(pointsRaceId: string, body?: ModulesPointsRacesEndpointsContractsPointsRacesUpdatePointsRaceRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public pointsRacesPointsRaceIdPut(pointsRaceId: string, body?: ModulesPointsRacesEndpointsContractsPointsRacesUpdatePointsRaceRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public pointsRacesPointsRaceIdPut(pointsRaceId: string, body?: ModulesPointsRacesEndpointsContractsPointsRacesUpdatePointsRaceRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public pointsRacesPointsRaceIdPut(pointsRaceId: string, body?: ModulesPointsRacesEndpointsContractsPointsRacesUpdatePointsRaceRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pointsRaceId === null || pointsRaceId === undefined) {
            throw new Error('Required parameter pointsRaceId was null or undefined when calling pointsRacesPointsRaceIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/pointsRaces/${encodeURIComponent(String(pointsRaceId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a PointsRace.
     * Creates a PointsRace based on the CreatePointsRaceRequest request.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pointsRacesPost(body?: ModulesPointsRacesEndpointsContractsPointsRacesCreatePointsRaceRequest, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public pointsRacesPost(body?: ModulesPointsRacesEndpointsContractsPointsRacesCreatePointsRaceRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public pointsRacesPost(body?: ModulesPointsRacesEndpointsContractsPointsRacesCreatePointsRaceRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public pointsRacesPost(body?: ModulesPointsRacesEndpointsContractsPointsRacesCreatePointsRaceRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/pointsRaces`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
